"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsEvents = exports.QuickLinkType = exports.MicrofrontendName = exports.MaintenancePages = exports.GWIPackageKeys = exports.Metric = exports.DashboardChartType = exports.TokenType = exports.OpenAccessHostURL = exports.EnvironmentEnum = void 0;
var EnvironmentEnum;
(function (EnvironmentEnum) {
    EnvironmentEnum["Development"] = "development";
    EnvironmentEnum["Testing"] = "testing";
    EnvironmentEnum["Staging"] = "staging";
    EnvironmentEnum["Production"] = "production";
})(EnvironmentEnum = exports.EnvironmentEnum || (exports.EnvironmentEnum = {}));
var OpenAccessHostURL;
(function (OpenAccessHostURL) {
    OpenAccessHostURL["development"] = "localhost:4200";
    OpenAccessHostURL["testing"] = "dashboards-testing.gwi.com";
    OpenAccessHostURL["staging"] = "dashboards-staging.gwi.com";
    OpenAccessHostURL["production"] = "dashboards.gwi.com";
})(OpenAccessHostURL = exports.OpenAccessHostURL || (exports.OpenAccessHostURL = {}));
var TokenType;
(function (TokenType) {
    TokenType["Authorization"] = "auth";
    TokenType["Refresh"] = "refresh";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
var DashboardChartType;
(function (DashboardChartType) {
    DashboardChartType["DataTable"] = "data_table";
    DashboardChartType["DivergingBarChart"] = "diverging_bar_chart";
    DashboardChartType["DonutChart"] = "donut_chart";
    DashboardChartType["HorizontalBarChart"] = "horizontal_bar_chart";
    DashboardChartType["LineChart"] = "line_chart";
    DashboardChartType["PieChart"] = "pie_chart";
    DashboardChartType["PieRadarChart"] = "pie_radar_chart";
    DashboardChartType["RadarChart"] = "radar_chart";
    DashboardChartType["RadialBarChart"] = "radial_bar_chart";
    DashboardChartType["StatCard"] = "stat_card";
    DashboardChartType["StatCardColored"] = "stat_card_colored";
    DashboardChartType["VerticalBarChart"] = "vertical_bar_chart";
})(DashboardChartType = exports.DashboardChartType || (exports.DashboardChartType = {}));
var Metric;
(function (Metric) {
    Metric["AudiencePercentage"] = "percentage";
    Metric["DataPointPercentage"] = "horizontal_percentage";
    Metric["Universe"] = "weighted_universe_count";
    Metric["Index"] = "index";
    Metric["Responses"] = "responses_count";
})(Metric = exports.Metric || (exports.Metric = {}));
var GWIPackageKeys = /** @class */ (function () {
    function GWIPackageKeys() {
    }
    GWIPackageKeys.P2Lib = '@globalwebindex/platform2-lib';
    GWIPackageKeys.RUC = '@globalwebindex/platform2-react-ui-components';
    GWIPackageKeys.WebComponents = '@globalwebindex/platform2-web-components';
    GWIPackageKeys.AudienceBuilder = '@globalwebindex/platform2-audience-builder';
    return GWIPackageKeys;
}());
exports.GWIPackageKeys = GWIPackageKeys;
var MaintenancePages = /** @class */ (function () {
    function MaintenancePages() {
    }
    MaintenancePages.Platform = 'platform-maintenance';
    MaintenancePages.MaintenanceSuffix = '-maintenance';
    return MaintenancePages;
}());
exports.MaintenancePages = MaintenancePages;
var MicrofrontendName;
(function (MicrofrontendName) {
    MicrofrontendName["CHART_BUILDER"] = "chart-builder";
    MicrofrontendName["AUDIENCES"] = "audiences";
    MicrofrontendName["DASHBOARDS"] = "dashboards";
    MicrofrontendName["DASHBOARDS_REACT"] = "dashboards-react";
    MicrofrontendName["INSIGHTS"] = "insights";
    MicrofrontendName["CROSSTABS"] = "crosstabs";
    MicrofrontendName["ACCOUNT_SETTINGS"] = "account-settings";
    MicrofrontendName["TV_STUDY"] = "tv-study";
    MicrofrontendName["TV_RF"] = "tv-rf";
    MicrofrontendName["ACTIVATION"] = "activation";
    MicrofrontendName["GLOBAL_SEARCH"] = "global-search";
    MicrofrontendName["HOME"] = "home";
    MicrofrontendName["HEADER"] = "header";
    MicrofrontendName["BOOK_DEMO"] = "book-demo";
})(MicrofrontendName = exports.MicrofrontendName || (exports.MicrofrontendName = {}));
var QuickLinkType;
(function (QuickLinkType) {
    QuickLinkType["Chart"] = "chart";
    QuickLinkType["Dashboard"] = "dashboard";
    QuickLinkType["Category"] = "category";
    QuickLinkType["HomePage"] = "homepage";
})(QuickLinkType = exports.QuickLinkType || (exports.QuickLinkType = {}));
var AnalyticsEvents;
(function (AnalyticsEvents) {
    AnalyticsEvents["P2Visited"] = "P2 Visited";
    AnalyticsEvents["FeedbackClicked"] = "P2 - Feedback Button Clicked";
    AnalyticsEvents["ReturnToPlatform"] = "P2 - Return to Current Platform";
    AnalyticsEvents["GotoApplicationCrosstabs"] = "P2 - Crosstabs Opened";
    AnalyticsEvents["GotoApplicationDashboards"] = "P2 - Dashboards Opened";
    AnalyticsEvents["GotoApplicationTvStudy"] = "P2 - TV Study Opened";
    AnalyticsEvents["GotoApplicationInsights"] = "P2 - Insights Opened";
    AnalyticsEvents["GotoApplicationCharts"] = "P2 - Charts - App Opened";
    AnalyticsEvents["GotoApplicationAudiences"] = "P2 - Audiences - App Opened";
    AnalyticsEvents["GotoApplicationAccountSettings"] = "P2 - User Menu Opened";
    AnalyticsEvents["QuickLinkClicked"] = "P2 - Homepage Quick Link clicked";
    AnalyticsEvents["OpenAccessDashboardsCTAclicked"] = "P2 - Open Access Dashboards - CTA Clicked";
    AnalyticsEvents["OpenAccessDashboardsFormSubmitted"] = "P2 - Open Access Dashboards - Form submitted";
    AnalyticsEvents["HomePageSearchSubmitted"] = "P2 - Homepage - Search submitted";
    AnalyticsEvents["HomePageSearchBarClicked"] = "P2 - Homepage - Search initiated";
    AnalyticsEvents["HomePageExampleClicked"] = "P2 - Homepage - example selected";
    AnalyticsEvents["HomePageBetaLabelClicked"] = "P2 - Homepage - Beta label clicked";
})(AnalyticsEvents = exports.AnalyticsEvents || (exports.AnalyticsEvents = {}));
